export default {};

export * from "./CopilotLicenseDetailsInput.schema";
export * from "./CopilotServiceNowGraphConnectorsInput.schema";
export * from "./CopilotTeamsExtensibilityInput.schema";
export * from "./DaneValidationInput.schema";
export * from "./ExchangeEasInput.schema";
export * from "./ExchangeEwsAccessInput.schema";
export * from "./ExchangeEwsTaskInput.schema";
export * from "./ExchangeImapInput.schema";
export * from "./ExchangeInboundSmtpInput.schema";
export * from "./ExchangeMrsProxyInput.schema";
export * from "./ExchangeOlaInput.schema";
export * from "./ExchangeOutboundSmtpInput.schema";
export * from "./ExchangePopInput.schema";
export * from "./ExoEasInput.schema";
export * from "./ExoEwsAccessInput.schema";
export * from "./ExoEwsTaskInput.schema";
export * from "./ExoExchangeDnsInput.schema";
export * from "./ExoImapInput.schema";
export * from "./ExoInboundSmtpInput.schema";
export * from "./ExoMrsEasInput.schema";
export * from "./ExoMrsImapInput.schema";
export * from "./ExoMrsPopInput.schema";
export * from "./ExoOlaInput.schema";
export * from "./ExoOutboundSmtpInput.schema";
export * from "./ExoPopInput.schema";
export * from "./ExoProvisioningInput.schema";
export * from "./FreeBusyTestInput.schema";
export * from "./LLMAPIPlaygroundInput.schema";
export * from "./MtaStsValidationInput.schema";
export * from "./OlkMobHmaInput.schema";
export * from "./OnPremSkypeAutodiscoverWebServiceInput.schema";
export * from "./OnPremSkypeConnectivityInput.schema";
export * from "./SmarthostResolveInput.schema";
export * from "./SslServerTestInput.schema";
export * from "./TeamsAOSPMigrationInput.schema";
export * from "./TeamsCalendarMissingInput.schema";
export * from "./TeamsCalendarPresenceInput.schema";
export * from "./TeamsChannelMeetingInput.schema";
export * from "./TeamsCreateTeamInput.schema";
export * from "./TeamsDialpadMissingInput.schema";
export * from "./TeamsDnsInput.schema";
export * from "./TeamsExchangeIntegrationInput.schema";
export * from "./TeamsExternalCollabInput.schema";
export * from "./TeamsFederationInput.schema";
export * from "./TeamsGuestAdditionInput.schema";
export * from "./TeamsGuestSigninInput.schema";
export * from "./TeamsInternalUserSearchInput.schema";
export * from "./TeamsMeetingDelegationInput.schema";
export * from "./TeamsMeetingExternalJoinInput.schema";
export * from "./TeamsMTRDeviceSigninInput.schema";
export * from "./TeamsOutlookAddinInput.schema";
export * from "./TeamsPhoneDeviceSigninInput.schema";
export * from "./TeamsPremiumDetailsInput.schema";
export * from "./TeamsRecordingInput.schema";
export * from "./TeamsSigninInput.schema";
export * from "./TeamsVirtualEventsInput.schema";
export * from "./TeamsVoicemailInput.schema";
